export enum RegisterType {
  Authorizations = "authorizations",
  BankAuthorizations = "bankAuthorizations",
  WithdrawnAuthorizations = "withdrawnAuthorizations",
  Wills = "wills",
  TZCertifications = "tzCertifications",
  ZOZCertifications = "zozCertifications",
  VehicleContracts = "vehicleContracts",
}

export const AuthorizationTypes = [RegisterType.Authorizations, RegisterType.BankAuthorizations];
